<template>
  <div>
    <el-tabs v-model="activeName" >
      <el-tab-pane v-for = "(item,index) in tabsList" :label="item.label" :name="item.name" :key="index">
        <slot name="tabContent"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'en-tabs',
  data () {
    return {
      activeName: 'second'
    }
  },
  props: {
    tabsList: {
      type: Array,
      required: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/scss"  lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabs/src/main.vue